@if(loading){
<app-loading-indicator
  *ngIf="loading"
  [is_my_files]="true"
></app-loading-indicator>
} @else{
<div class="search_top">
  <app-search
    (is_search_clicked)="search_clicked($event)"
    (searched_terms)="set_search_terms($event)"
    (results_populated_or_error)="this.loading=false"
  ></app-search>
</div>

<div class="results_div" *ngIf="this.commonservice.video_data && all_files">
  <div class="grid h-screen">
    <div class="col-12">
      <div class="right_side">
        <div class="col">
          <div
            class="file_cards"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="500"
            (scrolled)="onScroll()"
            [scrollWindow]="true"
          >
            @for (item of get_values(all_files); track $index) {
            <div class="file_card">
              <div class="card-img">
                <app-small-video-player
                  [id]="item.uuid + '_' + $index"
                  [video_data]="item"
                  [required_additional_options]="true"
                  (player_ready)="handle_player_ready($event)"
                ></app-small-video-player>
              </div>
            </div>
            }
          </div>
          <div class="loading_results" id="current_loader" *ngIf="get_length()>12">
              <span class="loader_get_data"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
